










































































import {Component, Mixins, Watch} from 'vue-property-decorator';
import EditDialog from '@/components/EditDialog.vue';
import EditDialogMixin from '@/mixins/EditDialogMixins';

@Component({
  components: {EditDialog},
})
export default class ProfileEditDialog extends Mixins(EditDialogMixin) {
  showPassword = false;

  errorKeyList = {
    name: 'name',
    email: 'email',
    password: 'password',
    phone: 'phone',
  };

  //Признак, что нужно сменить пароль
  needChangePassword = false;

  @Watch('dialog')
  async onDialog(value: boolean) {
    if (value) this.needChangePassword = false;
  }

  @Watch('needChangePassword')
  onChangedCheckbox(newVal: boolean) {
    if (!newVal) {
      this.data.userInfo.password = undefined;
    }
  }

  // поле необязательное, поэтому к регулярке добавляем !v
  get emailRules() {
    return [
      (v: any) =>
        !v ||
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v,
        ) ||
        'Неправильный адрес электронной почты',
    ];
  }

  save() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.$emit('submit');
    }
  }
}
